/**
 * Brand logomark — same shape as tax_recovery_web_v6's Logo component
 * (uses the 48x48 favicon as the mark). When v6 ever switches to an SVG
 * logo, mirror it here.
 */
interface LogoProps {
  className?: string;
  size?: number;
}

export default function Logo({ className, size = 32 }: LogoProps) {
  return (
    <img
      src="/favicon-48x48.png"
      width={size}
      height={size}
      className={className}
      alt="Input Recovery logo"
    />
  );
}
